import {
  BackupStatus,
  ConditionOperatorEnum,
  ResourceType,
} from '@repo/api-gw-sdk';

import {
  backupStatus,
  resourceId,
  resourceType,
  sourceRegion,
} from '@/components/queryBuilder/properties';
import { ResourcesSelector } from '@/components/resourcesSelection/resourcesSelector';
import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';

export const ResourcesSelectorWrapper = ({
  region,
  initialResourcesIds,
  selectedResourcesIds,
  addResource,
  removeResource,
  disabledDeletion,
}: {
  region: string | undefined;
  initialResourcesIds: string[];
  selectedResourcesIds: string[];
  addResource: (providerResourceId: string) => void;
  removeResource: (providerResourceId: string) => void;
  disabledDeletion?: boolean;
}) => {
  if (!region) {
    return (
      <ResourcesSelector
        freeTextAdd={false}
        disabled
        disabledDeletion={true}
        allResources={[]}
        addResource={addResource}
        description=''
        label=''
        resources={[]}
        removeResource={removeResource}
      />
    );
  }

  return (
    <ResourcesSelectorWithRegion
      region={region}
      initialResourcesIds={initialResourcesIds}
      selectedResourcesIds={selectedResourcesIds}
      addResource={addResource}
      removeResource={removeResource}
      disabledDeletion={disabledDeletion}
    />
  );
};

const ResourcesSelectorWithRegion = ({
  region,
  initialResourcesIds,
  selectedResourcesIds,
  addResource,
  removeResource,
  disabledDeletion,
}: {
  region: string;
  initialResourcesIds: string[];
  selectedResourcesIds: string[];
  addResource: (providerResourceId: string) => void;
  removeResource: (providerResourceId: string) => void;
  disabledDeletion?: boolean;
}) => {
  const dal = useDAL();
  const { data: resourcesData } = dal.inventory.useListResourceIdentifiers(
    createCombineCondition([
      {
        property: resourceType.name,
        operator: ConditionOperatorEnum.In,
        value: [ResourceType.AwsS3],
      },
      {
        property: sourceRegion.name,
        operator: ConditionOperatorEnum.In,
        value: [region],
      },
      {
        property: backupStatus.name,
        operator: ConditionOperatorEnum.NotIn,
        value: [BackupStatus.Dlsg],
      },
    ])
  );

  const { data: initialResourcesData } =
    dal.inventory.useListResourceIdentifiers(
      createCombineCondition([
        {
          property: resourceId.name,
          operator: ConditionOperatorEnum.In,
          value: initialResourcesIds,
        },
      ])
    );

  const allResources = (resourcesData?.resources ?? []).concat(
    initialResourcesData?.resources ?? []
  );

  return (
    <ResourcesSelector
      freeTextAdd={false}
      disabledDeletion={disabledDeletion}
      initialResourcesIds={initialResourcesIds}
      allResources={allResources}
      addResource={addResource}
      description=''
      label=''
      resources={selectedResourcesIds}
      removeResource={removeResource}
    />
  );
};
